<template>
    <div v-if="status && auth" style="display: inline-block">
        <p class="blue-red-hover-text" @click="openMeasuresModal">Меры поддержки</p>
        <modal v-if="showModal" :close="() => { showModal = false }" :printButton="false" :downloadButton="false">
            <template slot="modalHeader"><i class="uk-icon-hand-o-up"></i>  Меры поддержки субъекта МСП</template>
            <div slot="modalBody" class="measures-modal-body">
                <shestirenkaLoader v-if="loading" />
                <template v-else>
                    <p class="measures-modal-content-header">Согласно федеральному закону 209-ФЗ (статья 8) от 24.07.2007 «О развитии малого и среднего предпринимательства в РФ», организация является получателем следующих видов поддержки:</p>
                    <div v-for="(e, i) in measures" :key="i" class="measures-modal-content-item">
                        <p><b>{{e.form_title}}</b> – {{e.view_title}} в размере {{e.size}} {{e.unit_title}}</p>
                        <p>
                            <b>Орган, предоставивший поддержку:</b>
                            <a v-if="e.ogrn_pp" target="_blank" :href="`/company/${e.ogrn_pp}`">{{e.name_pp}}.</a>
                            <span v-else>{{e.name_pp}}.</span>
                        </p>
                        <p><b>Срок оказания поддержки:</b> {{e.date_start}} – {{e.date_support}}</p>
                        <p v-if="e.violations == 1" class="measures-modal-content-danger">Имеется информация о наличии нарушения порядка и условий предоставления поддержки.</p>
                        <p v-if="e.untargeted == 1" class="measures-modal-content-danger">Имеется информация о нецелевом использовании средств поддержки.</p>
                        <hr>
                    </div>
                </template>
            </div>
        </modal>
    </div>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import shestirenkaLoader from '@/components/ui/shestirenkaLoader.vue'

export default {
    components: {
        modal,
        shestirenkaLoader
    },
    data: () => ({
        showModal: false,
        loading: false,
        status: 0,
        measures: []
    }),
    methods: {
        openMeasuresModal() {
            this.showModal = true
            if(this.status) {
                this.getMeasures()
            }
        },
        getStatus() {
            this.$store.dispatch('RomAPI', {
                method: 'fns_msp_pp',
                data: {
                    action: 'status',
                    inn: window.company.inn,
                    ogrn: window.company.ogrn
                }
            }).then(e => {
                console.log('fns_msp_pp', e)
                if(e?.data?.data?.status) {
                    const status = e.data.data.status
                    this.status = status
                    return status
                }
            })
        },
        getMeasures() {
            this.loading = true
            return this.$store.dispatch('RomAPI', {
                method: 'fns_msp_pp',
                data: {
                    action: 'list',
                    inn: window.company.inn,
                    ogrn: window.company.ogrn
                }
            }).then(e => {
                console.log('getMeasures bankrupt', e)
                if(e?.data?.data?.list_events) {
                    this.measures = e.data.data.list_events
                }
            }).finally(() => {
                this.loading = false
            })
        }
    },
    created() {
        if(this.auth && window.company?.inn) {
            this.getStatus()
        }
    },
    computed: {
        auth(){
            return window.auth
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.blue-red-hover-text
    font-size: 13px !important

p
    margin: 5px 0 0 !important
    padding: 0 !important
    font-size: 14px !important

.measures-modal-content-danger
    color: #e74c3c

.measures-modal-body
    padding: 25px 50px

.measures-modal-content-item
    margin: 15px 0

.measures-modal-content-header
    color: #333
    font-size: 24px !important
    line-height: normal !important
    font-weight: normal !important
    margin: 0 0 20px auto
</style>